import { FormType, RxapForm, RxapFormControl, RxapFormGroup, UseFormControl, UseFormGroup } from 'eurogard-forms';
import { Injectable } from '@angular/core';
import { TimeslotDto } from 'open-api-service-app-settings/components/timeslot-dto';
import { TimeslotsDto } from 'open-api-service-app-settings/components/timeslots-dto';

@RxapForm('timeslots')
@Injectable()
export class TimeslotsFormGroup implements FormType<TimeslotsDto> {

  @UseFormControl({
    state: [],
  })
  monday!: RxapFormControl<TimeslotDto[]>;

  @UseFormControl({
    state: [],
  })
  tuesday!: RxapFormControl<TimeslotDto[]>;

  @UseFormControl({
    state: [],
  })
  wednesday!: RxapFormControl<TimeslotDto[]>;

  @UseFormControl({
    state: [],
  })
  thursday!: RxapFormControl<TimeslotDto[]>;

  @UseFormControl({
    state: [],
  })
  friday!: RxapFormControl<TimeslotDto[]>;

  @UseFormControl({
    state: [],
  })
  saturday!: RxapFormControl<TimeslotDto[]>;

  @UseFormControl({
    state: [],
  })
  sunday!: RxapFormControl<TimeslotDto[]>;

}

@RxapForm('alarm-group')
@Injectable()
export class AlarmGroupForm implements FormType<IAlarmGroupForm> {
  public readonly rxapFormGroup!: RxapFormGroup<IAlarmGroupForm>;

  @UseFormControl()
  public readonly isActive!: RxapFormControl<boolean>;

  @UseFormControl()
  public readonly delay!: RxapFormControl<number>;

  @UseFormControl()
  public readonly delayCascade!: RxapFormControl<number>;

  @UseFormControl()
  public readonly activeTime!: RxapFormControl<unknown>;

  @UseFormGroup(TimeslotsFormGroup)
  public readonly timeslots!: TimeslotsFormGroup;

  @UseFormControl({
    readonly: true,
  })
  public readonly name!: RxapFormControl<string>;

  @UseFormControl({
    readonly: true,
  })
  public readonly uuid!: RxapFormControl<string>;

}

export interface IAlarmGroupForm {
  uuid: string;
  name?: string;
  isActive?: boolean;
  delay?: number;
  activeTime?: unknown;
  timeslots: TimeslotsDto;
  delayCascade?: number;
}
